export const ELEMENT_MARGIN = '55px 0px 26px 0px';
export const FIRST_ELEMENT_MARGIN = '26px auto';

export const getHeadingMargin = (elementIndex: number): string => {
  return elementIndex === 0 ? FIRST_ELEMENT_MARGIN : ELEMENT_MARGIN;
};
